const getters = {
  headlines: state => state.article,
};

export default getters;
